import { defineComponent as _defineComponent } from 'vue';
import { computed, ref } from "vue";
//@ts-ignore missing typedefs
import VirtualList from "vue-virtual-scroll-list";
import MultipleViewItem from "./MultipleViewItem.vue";
import { useAnimationFrameScroll } from "@/composables/sensors/animationFrameScroll";
import { useAnimationFrameResizeObserver } from "@/composables/sensors/animationFrameResizeObserver";
export default /*#__PURE__*/ _defineComponent({
    __name: 'MultipleViewList',
    props: {
        histories: null,
        selectedHistories: null,
        filter: { default: "" }
    },
    setup(__props) {
        const props = __props;
        const scrollContainer = ref(null);
        const { arrived } = useAnimationFrameScroll(scrollContainer);
        const isScrollable = ref(false);
        useAnimationFrameResizeObserver(scrollContainer, ({ clientSize, scrollSize }) => {
            isScrollable.value = scrollSize.width >= clientSize.width + 1;
        });
        const scrolledLeft = computed(() => !isScrollable.value || arrived.left);
        const scrolledRight = computed(() => !isScrollable.value || arrived.right);
        return { __sfc: true, props, scrollContainer, arrived, isScrollable, scrolledLeft, scrolledRight, VirtualList, MultipleViewItem };
    }
});
